var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-content" },
    [
      _c("div", { staticClass: "modal-header" }, [
        _vm._v("\n    Figma Preview\n  "),
      ]),
      _vm._v(" "),
      _vm.currentFile && !_vm.currentFile.isFetching
        ? _c("FigmaLayerSelector")
        : _c("FigmaSpinnerLoader"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }